<div class="container-fluid-page">
    <div class=" profile_details">
        <div class="container-fluid page">
            <div class="d-flex page__box p-3 mt-2">
                &nbsp;&nbsp; Discussion Board
                <div class="export_csv">
                    <button class="add_button_new" mat-raised-button color="primary"
                        (click)="askPage()">Ask</button>&nbsp;&nbsp;
                    <button class="clear_button_export" style="float: right;" mat-raised-button color="primary"
                        (click)="openDialogexport1()">Export</button>
                </div>
            </div>
            <div class="profile_details">
                <div class="example-header">
                    <mat-card class="matCardForm" style="text-align: left;">
                        <mat-card-content class="pa-1">
                            <div>
                                <br />
                                <div class="row" style="margin-top: -20px;">
                                    <div class="col-3 topData">
                                        <p>Total Questions Posted Today</p>
                                        <p style="font-size: 2rem;">{{avgDiscussionquestionCount.todaysQuestion}}</p>
                                    </div>
                                    <div class="col-3 topData">
                                        <p>Total Questions in this Month</p>
                                        <p style="font-size: 2rem;">{{avgDiscussionquestionCount.currentMonthQuestion}}
                                        </p>
                                    </div>
                                    <div class="col-3 topData">
                                        <p>Most Questions from the State</p>
                                        <p style="font-size: 20px;">{{avgDiscussionquestionCount.mostQuestionState}}</p>
                                    </div>
                                    <div class="col-3 topData">
                                        <p>Questions Posted by Admins</p>
                                        <p style="font-size: 2rem;">
                                         
                                            {{avgDiscussionquestionCount.adminPosts}}
                                        </p>
                                    </div>
                                    <div class="col-9 pull-right">

                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                        <mat-card>
                            <div class="filter-card">


                                <mat-form-field style="width: 50% !important;">
                                    <input matInput [(ngModel)]="searchData" (change)="changeFn($event)"
                                        placeholder="Search">
                                </mat-form-field>&nbsp;&nbsp;<button type="submit" (click)="applyfilter(true)"
                                    class="btn btn-primary mat-primary search_bar">
                                    <mat-icon class="search_bar_icon">search</mat-icon>
                                </button>
                                <hr>
                                <mat-form-field>
                                    <input matInput type="text" name="daterange" placeholder="Date Range"
                                        [min]="minDate" autocomplete="off" [max]="maxDate" [alwaysShowCalendars]="true"
                                        ngxDaterangepickerMd [(ngModel)]="sharedate"
                                        [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}"
                                        [showCustomRangeLabel]="true" [ranges]="ranges"
                                        (change)="onDateRangeChanged(sharedate)" />
                                </mat-form-field>&nbsp;


                                <mat-form-field>
                                    <mat-label>Views</mat-label>
                                    <mat-select [(ngModel)]="viewData">
                                        <mat-option *ngFor="let x of viewsOption" [value]="x.viewValue">
                                            {{x.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp;

                                <mat-form-field>
                                    <mat-label>Likes</mat-label>
                                    <mat-select [(ngModel)]="likeData">
                                        <mat-option *ngFor="let x of likesOption" [value]="x.viewValue">
                                            {{x.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp;

                                <mat-form-field>
                                    <mat-label>Replies</mat-label>
                                    <mat-select [(ngModel)]="replyData">
                                        <mat-option *ngFor="let x of replyOption" [value]="x.viewValue">
                                            {{x.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp;
                                <!-- <mat-form-field>
                                    <mat-label>Roles</mat-label>
                                    <mat-select [(ngModel)]="roleName">
                                        <mat-option *ngFor="let food of rolebased" [value]="food.role">
                                            {{food.role}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp; -->

                                <mat-form-field>
                                    <mat-label>List Option</mat-label>
                                    <mat-select [(ngModel)]="listData">
                                        <mat-option *ngFor="let x of listOption" [value]="x.viewValue">
                                            {{x.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp;

                                <mat-form-field (click)="suche()">
                                    <mat-select [formControl]="bankMultiCtrl" [(ngModel)]="statedata" ngDefaultControl
                                        placeholder="States" [multiple]="true" #multiSelect
                                        noEntriesFoundLabel="'no matching country found'">
                                        <mat-option>
                                            <ngx-mat-select-search id="search1" [showToggleAllCheckbox]="true"
                                                (ngModelChange)="filterMyOptions($event);notFound()"
                                                [toggleAllCheckboxIndeterminate]="isIndeterminate"
                                                [toggleAllCheckboxChecked]="isChecked"
                                                (toggleAll)="toggleSelectAll($event)"
                                                [formControl]="bankMultiFilterCtrl"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let bank of filteredBanksMulti | async" [value]="bank">
                                            {{bank.stateName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp;&nbsp;

                                <mat-form-field (click)="sucheDistrict()">
                                    <mat-select [formControl]="districtMultiCtrl" [(ngModel)]="districtdata"
                                        ngDefaultControl placeholder="Districts" [multiple]="true" #multiSelect>
                                        <mat-option>
                                            <ngx-mat-select-search id="search1" [showToggleAllCheckbox]="true"
                                                [toggleAllCheckboxIndeterminate]="isIndeterminateDistrict"
                                                [toggleAllCheckboxChecked]="isCheckedDistrict"
                                                (toggleAll)="toggleSelectAlldistrict($event)"
                                                [formControl]="districtMultiFilterCtrl"
                                                (ngModelChange)="notFoundDistrict()">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let district of selectDistrict" [value]="district">
                                            {{district}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <button class="btn btn-primary mat-primary clear_button pull-right"
                                    style="margin-top: 12px;" (click)="clearFilter()">Clear Filter</button>
                                <button type="submit" style="margin-top: 12px; margin-right: 10px;"
                                    (click)="applyfilter(true)" class="btn btn-primary mat-primary pull-right">Apply
                                    Filter </button>
                                <div>
                                    <mat-chip-list #chipList aria-label="Filter selection">
                                        <mat-chip *ngFor="let filter of matChipArray;let i=index"
                                            [selectable]="selectable" [removable]="removable"
                                            (removed)="remove(i,filter.tag)">
                                            {{filter.name}}
                                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                        </mat-chip>
                                    </mat-chip-list>
                                </div>
                                <div class="text_filter_data" *ngIf="exportcsvdata">
                                    <p *ngIf="this.userlist.length == 0" style="color: red;"> There's no record found with the given
                                        criteria,
                                        please try again
                                        refining your search and filters </p>
                                </div>
                            </div>
                        </mat-card>


                    </mat-card>
                </div>
            </div>


            <!-- <div class="profile_details"> -->
            <div class="example-header">
                <mat-card class="matCard_table">
                    <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
                        <mat-table #table [dataSource]="dataSource1" matSort>

                            <ng-container matColumnDef="question">
                                <mat-header-cell *matHeaderCellDef mat-sort-header style=" display: none !important;">
                                    Questions </mat-header-cell>
                                <div (click)="listPage()">
                                    <mat-cell *matCellDef="let userlist" style="width: 30px; " (click)="flagClick()">
                                        <div class="div-table" (click)="flagClick(userlist.postId)">
                                            <div class="div-table-col someDiv">
                                                <!-- <img src="/assets/logo1.png" alt="Company Logo" style="height: 60px;margin-left: -14px;"> -->
                                                {{userlist.question}}</div><br>



                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                                    fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">

                                                    <path
                                                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                    <path
                                                        d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                </svg> {{userlist.view}}&nbsp;&nbsp;&nbsp;


                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                                    fill="currentColor" class="bi bi-hand-thumbs-up"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                                                </svg>{{userlist.likes}}&nbsp;&nbsp;&nbsp;

                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                                    fill="currentColor" class="bi bi-chat-square-text"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                    <path
                                                        d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
                                                </svg>&nbsp;{{userlist.totalReplies}}
                                                &nbsp;&nbsp;&nbsp;&nbsp;{{userlist.postBy}}
                                                ({{userlist.role}})&nbsp;&nbsp;&nbsp;&nbsp;{{userlist.postDate |
                                                date:'dd
                                                MMM, yyyy'}}
                                               
                                                <img src="/assets/flag.png" width="20px" height="20px" align="right" *ngIf="userlist.isFlag"
                                                    (click)="flagClick(userlist.postId)">
                                                <span> <i class=" divtag"
                                                        (click)="flagClick(userlist.postId)">
                                                        <!-- <mat-icon (click)="editPage(newData)">edit</mat-icon>&nbsp;&nbsp;
                                                        <mat-icon (click)="openDialog(newData)">delete</mat-icon> -->
                                                    </i>
                                                        
                                                    
                                                    </span>
                                                        <!-- <div> -->
                                                            <!-- <mat-icon (click)="editPage(newData)">edit</mat-icon>&nbsp;&nbsp;
                                                            <mat-icon (click)="openDialog(newData)">delete</mat-icon> -->
                                                        <!-- </div> -->

                                            </div>
                                          
                                        </div>
                                    </mat-cell>
                                </div>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>

                        <div>
                            <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)"
                                [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="" class="pagination">
                            </mat-paginator>
                        </div>
                    </div>

                </mat-card>
            </div>
            <!-- </div> -->
        </div>
    </div>
</div>







